var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.289551C4.6239 0.289551 0.25 4.66346 0.25 10.0395C0.25 15.4156 4.6239 19.7895 10 19.7895C15.3761 19.7895 19.75 15.4156 19.75 10.0395C19.75 4.66346 15.3761 0.289551 10 0.289551ZM8.21875 14.9324L4.44062 10.7338L5.55578 9.73017L8.18078 12.6467L14.4062 5.23299L15.5566 6.1958L8.21875 14.9324Z",
    fill: "#00BA88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.93e17b556695e7885dbdb4c5c2f31570.svg";
export { ForwardRef as ReactComponent };